import { type PropsWithChildren, useEffect, useRef } from 'react';

import { useAuth } from './AuthContext';
import { type SignInState } from './SignInState';

type CallbackPageProps = PropsWithChildren<{
  readonly onComplete?: (state?: SignInState) => void;
  readonly onFailure?: (error: unknown) => void;
}>;

export function CallbackPage({
  children,
  onComplete,
  onFailure,
}: CallbackPageProps) {
  const { finishSignIn } = useAuth();
  const called = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode double-invocation —
    // authorization codes are single-use and cannot be redeemed twice.
    if (called.current) return;
    called.current = true;

    finishSignIn().then(onComplete).catch(onFailure);
  }, [finishSignIn, onComplete, onFailure]);

  return <>{children ?? null}</>;
}
